import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=2c4d555e&scoped=true"
import script from "./FooterNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=2c4d555e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d555e",
  null
  
)

export default component.exports